import React, { Component } from 'react'
import firebase from './utils/firebase';
import classNames from 'classnames';
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";

var JsBarcode = require('jsbarcode');

const DEFAULT_SKIN = 'amp-flush'
const DEFAULT_RATIO = [16, 9]
let isFullScreen = false, waterString = '', playStarted = false, qrCodeArray = [], overlayIndex = 0, mapObj = {};
let loader = false, playerRef = null, sizeElement = null, diffHeight = 0, vidHeight = 0, vidWidth = 0;
let barOptions = { lineColor: "#000111", background: "#00000000", width: '20px', height: '20px', displayValue: false };

class AzureMP extends Component {
  constructor(props) {
    super(props)
    this.videoNode = React.createRef()
  }
  destroyPlayer() {
    this.player && this.player.dispose()
  }
  componentWillUnmount() {
    clearInterval(this.countdown);
    this.destroyPlayer()
  }
  shouldComponentUpdate(nextProps, nextState){
    // console.log('shouldComponentUpdate in AzureMP is called!'+this.props.currentUrl+' next='+nextProps.currentUrl);
    // let reloadComp = false;
    // if(this.props.currentUrl!=nextProps.currentUrl) {
    //   reloadComp = true;
    // }
    // if(this.props.widewineToken&&this.props.widewineToken!=nextProps.widewineToken) {
    //   reloadComp = true;
    // }
    // console.log('reloadComp='+reloadComp);
    // if(reloadComp) {
    //   console.log('updating player.');
    //   this.player = null;
    //   this.componentDidMount();
    // }
    // else if(this.props.movieTime!=nextProps.movieTime) {
    //   return true;
    // }
    return true;
 }
  componentDidMount() {
    console.log('comp did mount called.');
    const { skin } = this.props;
    playStarted = false; isFullScreen = false; waterString = ''; qrCodeArray = [];
    this.initialization = this.loadLibrary(skin).then(() => {
      this.createPlayer()
      this.setVideo()
      this.setMap();
    })
  }
  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.initialization.then(() => this.setVideo())
    }
  }
  loadLibrary = (skin = 'amp-flush') => {
    if (!loader && !window.amp) {
      loader = new Promise((resolve, reject) => {
      })
    }
    return loader || Promise.resolve({skin: skin})
  }
  timeout = async(ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  setMap = () => {
    for(let i=0; i<qrCodeArray.length; i++) {
      let arrValue = qrCodeArray[i].starttime;
      mapObj[arrValue] = i;
    }
  }
  async setVideo() {
    const { src, subtitles, userId, uploadId, movieTime, usersubtitle, streamHeight, streamWidth,
       locatorName, currentCountry } = this.props;
    this.player.src(src, subtitles);
    while(playerRef.currentTime()<5&&movieTime>5000) {
      console.log('badhai ho2='+playerRef.currentTime()+' time='+Date.now());
      playerRef.currentTime(movieTime/1000);  
      await this.timeout(1000);
      this.props.videoStarted();
    }
    this.player.addEventListener('disposing', function() {
      console.log('player disposing event. userId='+userId+' uploadId='+uploadId);
      let resumeTime = playerRef.currentTime();  
      if(userId>0&&uploadId>0&&resumeTime>5) {
        let duration = playerRef.duration();
        let subLanguage = '';
        try {
          let currentTrack = playerRef.getCurrentTextTrack();
          console.log('player disposing event. currentTrack='+currentTrack.mode+' lang='+currentTrack.language);
          subLanguage = currentTrack.language;
        } catch(e) {};
        // 20 instead of 2 so that resumeTime only gets stored before 20 seconds of movie completion.
        if(duration-2>resumeTime) {
          var updates = {};
          let movieObj = { resumeTime: Math.round(resumeTime*1000), subtitle: subLanguage };
          updates['resumeObject'] = movieObj;
          firebase.database().ref('users/'+userId+'/'+locatorName+'/'+currentCountry).update(updates);
        }
      }
    });
    // this.player.addEventListener('downloadbitratechanged', (rate) => {
    //   console.log('player currentDownloadBitrate='+playerRef.currentDownloadBitrate()+' rate='+rate);
    // });
    this.player.addEventListener('play', (playEvent) => {
      console.log('player played');
      playStarted = true;
      this.props.videoStarted();
    });
    // this.player.addEventListener('fullscreenchange', (resizeEvent) => {
    //   if(waterString) {
    //     isFullScreen = !isFullScreen;
    //     vidWidth = sizeElement.offsetWidth;
    //     vidHeight = (vidWidth*streamHeight)/streamWidth;
    //     let totalHeight = isFullScreen ? window.outerHeight : sizeElement.offsetHeight;
    //     diffHeight = totalHeight - vidHeight;
    //     console.log('resizeEvent width='+vidWidth+' totalHeight='+totalHeight+' vidHeight='+vidHeight+' diffHeight='+diffHeight);
    //     if(isFullScreen) {
    //       this.oneTimeOverlay();
    //     } else {
    //       var div = document.getElementById('mySpan');
    //       if(div) { div.remove() };
    //     }
    //   }
    // });
    this.player.addEventListener('pause', (pauseEvent) => {
      console.log('player paused');
      if(!playStarted) {
        playStarted = true;
        this.props.videoStarted();
      }
      let eventDetails = { eventName: "moviePaused", playerState: "STATE_PAUSED" };
      this.props.onDatabaseEvents(eventDetails);
    });
    // this.player.addEventListener('timeupdate', (progress) => {
    //   if(waterString&&!showingOverlay) {
    //     if(isFullScreen) {
    //       showingOverlay = true;
    //       this.oneTimeOverlay();  
    //     }
    //   }
    // });
    this.player.addEventListener('error', (player, err) => {
      console.log('error came.');
      var errorMy = this.player.error();
      if(errorMy&&errorMy.code) {
        console.log('player error='+JSON.stringify(errorMy));
        let errorCode = errorMy.code+'';
        if((errorCode&&errorCode.includes('542113798'))||(errorMy.message&&errorMy.message.includes('00200191'))) {
          // auth error in playing movie. try refreshing the token. Example - {"code":542113798,"message":"Http: 0x00200191"}
          this.props.updateCDN(true);
          let eventDetails = { eventName: "WebPlayerError", playerState: "STATE_ENDED" };
          this.props.onDatabaseEvents(eventDetails);
        } else {
          this.props.updateCDN(false);
          let eventDetails = { eventName: "WebPlayerError", playerState: "STATE_ENDED" };
          this.props.onDatabaseEvents(eventDetails);
        }
      }
    });
    this.player.addEventListener('ended', (endedEvent) => {
      console.log('movie ended.');
      let eventDetails = { eventName: "movieComplete", playerState: "STATE_ENDED" };
      this.props.onDatabaseEvents(eventDetails);
      this.props.onVideoComplete();
      var updates = {};
      let movieObj = { resumeTime: 0 };
      updates['resumeObject'] = movieObj;
      firebase.database().ref('users/'+userId+'/'+locatorName+'/'+currentCountry).update(updates);
    });
    console.log('badhai ho1');
    if(usersubtitle) {
      let tracks = playerRef.textTracks();
      for (let i = 0; i < tracks.length; i++) {
        let track = tracks[i];
        if (track.language === usersubtitle) {
          playerRef.setActiveTextTrack(track);
        }
      }
    }
    if(waterString) {
      // this.setLayout();
    }
  }
  async oneTimeOverlay() {
    playerRef.diagnoverlay({"topHeight": diffHeight/2, "vidHeight": vidHeight, "vidWidth": vidWidth, "opacity": 0.3 });
    await this.timeout(100);
    var element = document.getElementById("barcode");
    if(element) {
      JsBarcode(element, waterString, barOptions);
    }
    var element = document.getElementById("barcode2");
    if(element) {
      JsBarcode(element, waterString, barOptions);
    }
    console.log('showing String='+waterString);
    this.countdown = setInterval(this.overlayLogic, 1000);
  }
  overlayLogic = () => {
    let currentTime = playerRef.currentTime();
    currentTime = Math.floor(currentTime);
    console.log('timeupdate='+currentTime);
    let timeIndex = mapObj[currentTime];
    if(timeIndex>=0) {
      console.log('index='+timeIndex);
      overlayIndex = timeIndex;
      this.setLayout(overlayIndex);
    }
  }
  async setLayout(overlayIndex) {
    console.log('layout set');
    var qrElement = document.getElementById("qrcode");
    if(qrElement) {
      qrElement.style.display = "";
      qrElement.style.top = qrCodeArray[overlayIndex].ycoord+'%';
      qrElement.style.left = qrCodeArray[overlayIndex].xcoord+'%';
      qrElement.style.position = "absolute";
      ReactDOM.render(<QRCode value={waterString} bgColor="#00000000" fgColor={qrCodeArray[overlayIndex].color} size={40} />, qrElement);
      let duration = qrCodeArray[overlayIndex].duration;
      await this.timeout(duration*1000);
      if(qrElement) { qrElement.style.display = "none"; };  
    }
  }
  createPlayer() {
    const { options, onInstanceCreated, waterMarkValue, qrcodeInfo, streamHeight, streamWidth } = this.props
    waterString = waterMarkValue;
    qrCodeArray = qrcodeInfo;
    const defaultOptions = {
      controls: true,
      logo: { enabled: false },
    }
    this.player = window.amp(
      this.videoNode.current,
      Object.assign({}, defaultOptions, options)
    );
    playerRef = this.player;
    sizeElement = document.getElementsByClassName("vjs-player")[0];
    // if(sizeElement) {
    //   vidWidth = sizeElement.offsetWidth;
    //   vidHeight = (vidWidth*streamHeight)/streamWidth;
    //   diffHeight = sizeElement.offsetHeight - vidHeight;
    //   console.log('resizeEvent width='+vidWidth+' totalHeight='+sizeElement.offsetHeight+' vidHeight='+vidHeight+' diffHeight='+diffHeight);
    // }
    onInstanceCreated && onInstanceCreated(this.player)
  }
  getRatioStyles(ratio) {
    if (!ratio) {
      return {}
    }
    return { paddingBottom: (ratio[1] / ratio[0]) * 100 + '%' }
  }
  render() {
    const {
      className,
      skin = DEFAULT_SKIN,
      adaptRatio = DEFAULT_RATIO,
      cornerPlayBtn
    } = this.props
    return (
      <div
        style={this.getRatioStyles(adaptRatio)}
        className={classNames(
          { 'azure-mp-container': adaptRatio },
          className
        )}>
        <video
          ref={this.videoNode}
          className={classNames('azuremediaplayer', `${skin}-skin`, {
            'amp-big-play-centered': !cornerPlayBtn
          })}
        />
      </div>
    )
  }
}

export default AzureMP